import React from 'react';
import Navbar from '../../components/Navbar';
import { Percent, TrendingUp, CreditCard, Repeat } from 'lucide-react';

const FeeSchedule = () => {
    return (
        <div className="bg-[#0b0e11] min-h-screen text-gray-100 font-sans selection:bg-blue-500/30">
            <Navbar />

            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="text-center mb-16">
                    <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Fee Schedule</h1>
                    <p className="text-gray-400 max-w-2xl mx-auto">
                        Transparent and competitive fees for all your trading needs.
                    </p>
                </div>

                <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2">

                    {/* Spot Trading Fees */}
                    <div className="bg-[#181a20] rounded-3xl p-8 border border-gray-800 flex flex-col">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="bg-blue-500/10 p-3 rounded-xl text-blue-500">
                                <TrendingUp size={24} />
                            </div>
                            <h2 className="text-2xl font-bold text-white">Spot Trading</h2>
                        </div>

                        <div className="flex-1">
                            <table className="w-full text-left">
                                <thead>
                                    <tr className="border-b border-gray-700">
                                        <th className="py-3 text-gray-500 font-medium text-sm">Trading Pair</th>
                                        <th className="py-3 text-gray-500 font-medium text-sm text-right">Maker Fee</th>
                                        <th className="py-3 text-gray-500 font-medium text-sm text-right">Taker Fee</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-800">
                                    <tr>
                                        <td className="py-4 text-white font-medium">Standard Pairs</td>
                                        <td className="py-4 text-gray-300 text-right">0.10%</td>
                                        <td className="py-4 text-gray-300 text-right">0.10%</td>
                                    </tr>
                                    <tr>
                                        <td className="py-4 text-white font-medium">BNB Deduction (25% off)</td>
                                        <td className="py-4 text-green-400 text-right">0.075%</td>
                                        <td className="py-4 text-green-400 text-right">0.075%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Futures Trading Fees */}
                    <div className="bg-[#181a20] rounded-3xl p-8 border border-gray-800 flex flex-col">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="bg-purple-500/10 p-3 rounded-xl text-purple-500">
                                <Repeat size={24} />
                            </div>
                            <h2 className="text-2xl font-bold text-white">Futures Trading</h2>
                        </div>

                        <div className="flex-1">
                            <table className="w-full text-left">
                                <thead>
                                    <tr className="border-b border-gray-700">
                                        <th className="py-3 text-gray-500 font-medium text-sm">Contract Type</th>
                                        <th className="py-3 text-gray-500 font-medium text-sm text-right">Maker Fee</th>
                                        <th className="py-3 text-gray-500 font-medium text-sm text-right">Taker Fee</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-800">
                                    <tr>
                                        <td className="py-4 text-white font-medium">USDT-M Futures</td>
                                        <td className="py-4 text-gray-300 text-right">0.02%</td>
                                        <td className="py-4 text-gray-300 text-right">0.04%</td>
                                    </tr>
                                    <tr>
                                        <td className="py-4 text-white font-medium">COIN-M Futures</td>
                                        <td className="py-4 text-gray-300 text-right">0.01%</td>
                                        <td className="py-4 text-gray-300 text-right">0.05%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Deposit & Withdrawal Fees */}
                    <div className="bg-[#181a20] rounded-3xl p-8 border border-gray-800 md:col-span-2">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="bg-green-500/10 p-3 rounded-xl text-green-500">
                                <CreditCard size={24} />
                            </div>
                            <h2 className="text-2xl font-bold text-white">Example Withdrawal Fees</h2>
                        </div>
                        <p className="text-gray-400 mb-6 text-sm">
                            * Fees are dynamic and subject to network conditions.
                        </p>

                        <div className="overflow-x-auto">
                            <table className="w-full text-left">
                                <thead>
                                    <tr className="border-b border-gray-700 bg-gray-800/30">
                                        <th className="px-6 py-4 text-gray-500 font-medium text-sm rounded-l-lg">Asset</th>
                                        <th className="px-6 py-4 text-gray-500 font-medium text-sm">Network</th>
                                        <th className="px-6 py-4 text-gray-500 font-medium text-sm text-right rounded-r-lg">Withdrawal Fee</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-800">
                                    <tr>
                                        <td className="px-6 py-4 text-white font-bold">Bitcoin (BTC)</td>
                                        <td className="px-6 py-4 text-gray-300">Bitcoin</td>
                                        <td className="px-6 py-4 text-gray-300 text-right">0.0005 BTC</td>
                                    </tr>
                                    <tr>
                                        <td className="px-6 py-4 text-white font-bold">Ethereum (ETH)</td>
                                        <td className="px-6 py-4 text-gray-300">ERC20</td>
                                        <td className="px-6 py-4 text-gray-300 text-right">0.005 ETH</td>
                                    </tr>
                                    <tr>
                                        <td className="px-6 py-4 text-white font-bold">USDT</td>
                                        <td className="px-6 py-4 text-gray-300">TRC20</td>
                                        <td className="px-6 py-4 text-gray-300 text-right">1 USDT</td>
                                    </tr>
                                    <tr>
                                        <td className="px-6 py-4 text-white font-bold">USDT</td>
                                        <td className="px-6 py-4 text-gray-300">ERC20</td>
                                        <td className="px-6 py-4 text-gray-300 text-right">10 USDT</td>
                                    </tr>
                                    <tr>
                                        <td className="px-6 py-4 text-white font-bold">BNB</td>
                                        <td className="px-6 py-4 text-gray-300">BEP20</td>
                                        <td className="px-6 py-4 text-gray-300 text-right">0.0005 BNB</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default FeeSchedule;
